import { apiClient } from 'common/utils/api'

export const confirmEmail = async (token: string) => {
  await apiClient().post('Accounts/verify-email', {
    json: {
      token
    }
  })
}
